import type { SortKey } from "@/lib/articles";

export type RangeKey = "all" | "week" | "month" | "quarter";

interface CategoryFiltersProps {
  subcategories: { id: string; name: string }[];
  activeSub: string;
  onSubChange: (value: string) => void;
  sort: SortKey;
  onSortChange: (value: SortKey) => void;
  range: RangeKey;
  onRangeChange: (value: RangeKey) => void;
}

const SORTS: { key: SortKey; label: string; icon: string }[] = [
  { key: "latest", label: "最新", icon: "ri-time-line" },
  { key: "hot", label: "最热", icon: "ri-fire-line" },
];

const RANGES: { key: RangeKey; label: string }[] = [
  { key: "all", label: "不限时间" },
  { key: "week", label: "近一周" },
  { key: "month", label: "近一月" },
  { key: "quarter", label: "近三月" },
];

export default function CategoryFilters({
  subcategories,
  activeSub,
  onSubChange,
  sort,
  onSortChange,
  range,
  onRangeChange,
}: CategoryFiltersProps) {
  const allSubs = [{ id: "all", name: "全部" }, ...subcategories];

  return (
    <div className="w-full rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-wrap items-center gap-2">
        <span className="mr-1 text-sm font-medium text-foreground-700">子分类：</span>
        {allSubs.map((sub) => (
          <button
            key={sub.id}
            type="button"
            onClick={() => onSubChange(sub.id)}
            className={`rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer whitespace-nowrap ${
              activeSub === sub.id
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
            }`}
          >
            {sub.name}
          </button>
        ))}
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-3 border-t border-background-200 pt-4">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm font-medium text-foreground-700">排序：</span>
          <div className="flex items-center gap-1 rounded-full bg-background-100 px-1 py-1">
            {SORTS.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => onSortChange(item.key)}
                className={`flex items-center gap-1 rounded-full px-3 py-1 text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  sort === item.key
                    ? "bg-secondary-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                <i className={`${item.icon} w-4 h-4 flex items-center justify-center`}></i>
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm font-medium text-foreground-700">发布时间：</span>
          <div className="flex flex-wrap items-center gap-2">
            {RANGES.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => onRangeChange(item.key)}
                className={`rounded-full px-3 py-1 text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  range === item.key
                    ? "bg-accent-500 text-foreground-950"
                    : "bg-background-100 text-foreground-700 hover:bg-accent-100"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}